import { render, staticRenderFns } from "./DistanceChart.vue?vue&type=template&id=24848cde&"
import script from "./DistanceChart.vue?vue&type=script&lang=js&"
export * from "./DistanceChart.vue?vue&type=script&lang=js&"
import style0 from "./DistanceChart.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports